import styled from 'styled-components';
import { MenuSolid } from '@simplywallst/ui-core/icons';

interface MenuProps {
  readonly $isWhite?: boolean;
}

export const Menu = styled(MenuSolid)<MenuProps>`
  ${(props) => (props.$isWhite ? 'fill: white' : '')};
`;
